<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <public-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-lg mx-auto">
                <div v-if="resetLinkSent">
                    <h3 class="font-bold text-4xl mb-4">{{ $t("checkEmail") }}</h3>
                    <p class="mb-6">{{ $t("waitForPasswordLinkEmail") }}</p>

                    <div class="mt-10" v-if="token">
                        <router-link class="text-gray-500 text-sm"
                                     :to="{name: 'reset-password', params: {token: token}}">
                            {{ $t("confirmVerification") }}
                        </router-link>
                    </div>
                </div>
                <div v-if="!resetLinkSent">
                    <h3 class="font-bold text-2xl mb-4">{{ $t("forgotPassword") }}</h3>
                    <p class="text-sm mb-6">{{ $t("enterEmailForPasswordReset") }}</p>
                    <form autocomplete="off">
                        <k-input
                                class="mb-4"
                                id="email"
                                label="Email"
                                v-model="form.email"
                                :field-errors="validation.fieldErrors"
                                type="email"/>
                        <div class="mt-6">
                            <k-button @click.native.prevent="onSubmit">
                                {{ $t("send") }}
                            </k-button>
                        </div>
                    </form>
                </div>
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
    import PublicHeader from '@investor/components/PublicHeader';

    export default {
        components: {
            PublicHeader,
        },
        data() {
            return {
                resetLinkSent: false,
                token: null,
                form: {
                    email: null
                },
                validation: {
                    fieldErrors: {}
                }
            }
        },
        methods: {
            async onSubmit() {
                this.validation = {
                    fieldErrors: {}
                };
                try {
                    const resp = await this.$post('public/send-reset-password-link', this.form);
                    // for testing only, on production will be empty
                    this.token = resp.token;
                    this.resetLinkSent = true;
                } catch (error) {
                    if (error.response && error.response.status === 400) {
                        this.validation = error.response.data;
                        this.$scrollToErrorField();
                    }
                }
            },
            fieldError(field) {
                return this.validation.fieldErrors[field];
            },
        }
    }
</script>


